module.exports = __webpack_public_path__ + "static/sdk_logo-fec354dd756ed1759399174e65718674.gif";